import React from 'react';
import { SingleSidebar } from '@esg/ui';
import { teamSidebarConstants } from '../../Constants';
const teamSidebar = teamSidebarConstants[0];


export const TeamSidebar: React.FC = () => {
    return (
        <SingleSidebar
            label={teamSidebar.label || ''}
            PreIcon={teamSidebar.Icon}
            value={teamSidebar.path}
        />
    );
};
